import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import type { SavedOrder } from "../orders/orderTypes";

export interface CustomerOrderNameData {
  value: string;
}

export function CustomerOrderNameDialog(props: {
  data: CustomerOrderNameData;
  onUpdate(name: string): Promise<SavedOrder>;
  onClose(): void;
}) {
  const [name, setName] = useState(props.data.value);

  const hasChanged = name.trim() !== props.data.value.trim();
  const canSave = hasChanged && name.trim().length > 0;

  const onSave = async () => {
    if (!canSave) return;

    await props.onUpdate(name.trim());
    props.onClose();
  };

  return (
    <Dialog open onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <EditOutlinedIcon color="primary" />
        Edytuj nazwę zamówienia
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <TextField
          autoFocus
          fullWidth
          label="Nazwa zamówienia"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && canSave) {
              void onSave();
            }
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions>
        <Button disabled={!canSave} onClick={() => void onSave()}>
          Zapisz
        </Button>
        <Button onClick={props.onClose}>Anuluj</Button>
      </DialogActions>
    </Dialog>
  );
}
